import * as React from 'react';
import useSiteMetadata from '../../hooks/useSiteMetadata';

export type SeoProps = {
  title?: string;
  description?: string;
  pathname?: string;
  children?: React.ReactNode;
};

const Seo = ({ title, description, pathname, children }: SeoProps): JSX.Element => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
    twitterUsername,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    twitter: twitterUsername,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:type" content="website" />
      <meta name="og:title" content={seo.title} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitter} />
      <meta name="facebook-domain-verification" content="x76nc8naedgyu8m2wgudmajqhq9fd4" />
      {children}
    </>
  );
};

export default Seo;
